import React, { useState } from "react";
import { FaFilePdf, FaList, FaCog, FaBlog } from "react-icons/fa"; // Added FaBlog
// Import a clean chat icon matching HeroUI's aesthetic
import { BsChatDots } from "react-icons/bs";
import ChatManager from "./ChatManager/ChatManager";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import ContractTemplateEditor from "../components/ContractTemplateEditor";
import LeadsTable from "../components/LeadsTable";
import InvoicesTable from "../components/InvoicesTable";
import BlogEditorPage from "../pages/BlogEditor/BlogEditorPage"; // ← 1. Import your Blog Editor Page
import { useAuth } from "../context/AuthContext";
import "../css/Sidebar.css";

const HEADER_HEIGHT = 64;

function Dashboard() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("CRM");
  const [pendingLeadId, setPendingLeadId] = useState(null);

  const handleOpenWhatsapp = (lead) => {
    setPendingLeadId(lead.id);
    setSelectedMenu("Chats");
  };

  const menuItems = [
    { label: "CRM", icon: <FaList /> },
    { label: "Chats", icon: <BsChatDots /> },
    { label: "Invoices", icon: <FaList /> },
    { label: "Contract Editor", icon: <FaFilePdf /> },
    { label: "Blogs & Newsletter", icon: <FaBlog /> }, // ← 2. Added to Sidebar Menu
    { label: "User Management", icon: <FaCog />, onClick: () => alert("Settings") }
  ];

  const sidebarWidth = isOpen ? 220 : 64;
  const { userName } = useAuth();

  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      overflow: "hidden",
      background: "#f5f5f5",
      position: "relative",
    }}>

      <Sidebar
        menuItems={menuItems}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setSelectedMenu={setSelectedMenu}
        selectedMenu={selectedMenu}
      />

      {/* Everything to the right of sidebar */}
      <div style={{
        marginLeft: sidebarWidth,
        width: `calc(100% - ${sidebarWidth}px)`,  
        transition: "margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}>
        <Header isOpen={isOpen} selectedMenu={selectedMenu} />

        {/* Main content */}
        <div style={{
          position: "fixed",                            // ← fixed so it doesn't scroll with page
          top: HEADER_HEIGHT,                           // ← start below fixed header
          left: sidebarWidth,                           // ← start right of fixed sidebar
          right: 0,
          bottom: 0,
          transition: "left 0.25s cubic-bezier(0.4,0,0.2,1)",
          padding: 5,
          overflowY: "auto",                            // CRM / Invoices tables scroll here
          overflowX: "hidden",
          background: "#f5f5f5",
        }}>
          {selectedMenu === "CRM" && <LeadsTable onOpenWhatsapp={handleOpenWhatsapp} />}
          {selectedMenu === "Chats" && (
            <ChatManager
              pendingLeadId={pendingLeadId}
              onPendingLeadHandled={() => setPendingLeadId(null)}
            />
          )}
          {selectedMenu === "Invoices" && <InvoicesTable />}
          {selectedMenu === "Contract Editor" && <ContractTemplateEditor />}
          {selectedMenu === "Blogs & Newsletter" && <BlogEditorPage />} {/* ← 3. Conditional render */}
        </div>
      </div>

    </div>
  );
}

export default Dashboard;